import script from "./CreateDoujinView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateDoujinView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__